import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";
import moment from "moment";

import { useGetSubscribedUsersQuery } from "../../../store/reducers/adminApi";

export function SubscribedUsers() {
    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    const { data: users, isFetching } = useGetSubscribedUsersQuery(page);

    const renderUserRow = (user: any) => {
        // Calculate time left in subscription
        const endDate = user.subscription_end_date ? new Date(user.subscription_end_date) : null;
        const today = new Date();
        const daysLeft = endDate ? Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)) : 0;

        // Get status display
        const getStatusDisplay = () => {
            if (!user.subscription_status) return null;

            switch(user.subscription_status) {
                case 'active':
                    return <Badge bg="success">Active</Badge>;
                case 'canceled':
                    return <Badge bg="warning">Canceled</Badge>;
                case 'expired':
                    return <Badge bg="danger">Expired</Badge>;
                default:
                    return null;
            }
        };

        return (
            <tr key={user.userID} onClick={() => navigate(`/user/${user.userID}`)}>
                <td>{user.email}</td>
                <td>{user.name}</td>
                <td>{user.subscription_type || 'Unknown'}</td>
                <td>{getStatusDisplay()}</td>
                <td>
                    {user.subscription_start_date
                        ? moment(user.subscription_start_date).format("MM-DD-YYYY")
                        : 'N/A'}
                </td>
                <td>
                    {user.subscription_end_date
                        ? moment(user.subscription_end_date).format("MM-DD-YYYY")
                        : 'N/A'}
                </td>
                <td>
                    {daysLeft > 0
                        ? `${daysLeft} days`
                        : (user.subscription_status === 'active' ? 'Overdue' : 'Expired')}
                </td>
            </tr>
        );
    };

    return (
        <div>
            <h2 className="mb-4">Subscribed Users</h2>

            <div className="mb-3">
                <div>Page # {page}</div>
                {isFetching && <div className="my-3">Loading...</div>}
            </div>

            <Table striped bordered hover className="table-hover">
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Name</th>
                        <th>Subscription Type</th>
                        <th>Status</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Time Remaining</th>
                    </tr>
                </thead>
                <tbody>
                    {users?.map(renderUserRow)}
                    {users?.length === 0 && (
                        <tr>
                            <td colSpan={7} className="text-center">No subscribed users found</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            <div className="d-flex align-items-center gap-2">
                <span>Current Page: {page}</span>
                {page > 1 && (
                    <button
                        className="btn btn-secondary"
                        onClick={() => setPage(page - 1)}
                    >
                        Previous
                    </button>
                )}
                {users?.length > 0 && (
                    <button
                        className="btn btn-secondary"
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>
                )}
            </div>
        </div>
    );
}